<template>
  <div v-if="!canBeChecked">
    <button class="button is-light is-circle" disabled="disabled">
      <i class="fas fa-ban"></i>
    </button>
  </div>
  <div v-else>
    <button class="button" @click.prevent.stop="selectItem"
            :class="[{'is-success':isChecked}, multiselectionClass ? multiselectionClass : 'is-circle is-small is-info']">
      <i :class="isChecked ? 'fas fa-check' : 'fal fa-plus'"></i>
    </button>
  </div>
</template>

<script>
  import { isEmpty } from 'lodash'

  export default {
    name: 'MultiselectButton',
    props: {
      data: {
        type: [String, Object],
        required: true
      },
      isChecked: {
        type: Boolean,
        default: false
      },
      multiselection: {
        type: Boolean,
        default: false
      },
      checkAvailable: Object,
      multiselectionClass: String
    },
    computed: {
      canBeChecked () {
        if (this.multiselection && !isEmpty(this.checkAvailable)) {
          return this.checkAvailable.values.includes(this.data[this.checkAvailable.key])
        } else {
          return true
        }
      }
    },
    methods: {
      selectItem (e) {
        this.$emit('selected', {data: this.data.pk, e})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/utils/MultiselectButton.vue